import { getTotalDetail, getTotalList } from '@/services/accountProcess/fb/totalAccount'
import { getReviewDetail, getReviewList } from '@/services/accountProcess/fb/reviewAccount'

export type IAccountProcessType = 'total' | 'review' | ''

const listService = {
  total: getTotalList,
  review: getReviewList,
}

const detailService = {
  total: getTotalDetail,
  review: getReviewDetail,
}

export {
  listService,
  detailService,
}
